import type { AxiosRequestConfig } from 'axios'
import { API_NOTIFICATION_URL } from '../constants/base-urls'
import type { INotification, INotificationDetail, IPaginationResponse } from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_NOTIFICATION_URL,
  withAuth: true,
})

type FetchNotificationParams = {
  group: INotificationDetail['group']
  skip?: number
  limit?: number
  sortedField?: 'created_at'
  sortDirection?: 'DESC' | 'ASC'
}

export const fetchNotification = (params: FetchNotificationParams, config?: AxiosRequestConfig) => {
  return axios
    .get<{ data: Omit<IPaginationResponse<INotification>, 'page' | 'limit'> }>(`/notifications`, { params: { ...params }, ...config })
    .then((response) => response.data.data)
}

export const markNotificationAsRead = (oid: string) => {
  return axios.patch(`/notifications/${oid}`).then((response) => response.data.data)
}

export const markAllNotificationsAsReadByGroup = (group: INotificationDetail['group']) => {
  return axios.patch(`/notifications/read-all/${group}`).then((response) => response.data.data)
}

export const getDetailNotifications = () => {
  return axios.get<{ data: INotificationDetail[] }>(`/notifications/details`).then((response) => response.data.data)
}
